import { render, staticRenderFns } from "./CoreLayoutContent.vue?vue&type=template&id=fd0126c8&scoped=true&functional=true"
import script from "./CoreLayoutContent.vue?vue&type=script&lang=js"
export * from "./CoreLayoutContent.vue?vue&type=script&lang=js"
import style0 from "./CoreLayoutContent.vue?vue&type=style&index=0&id=fd0126c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "fd0126c8",
  null
  
)

export default component.exports